import { AspectRatioContainer, Container, Image, ThemeProvider } from '@volkswagen-onehub/components-core';
import * as React from 'react';
import styled from 'styled-components';
import { IMAGE_DEFAULT_VWLOGO } from '../../../../app';
import { Bonus, CarouselModeEnum } from '@esportal/portal-service';
import { BonusDescription } from './bonus-description';
import { bonusCardBackgroundColor, isNewBrandDesign } from '../../../../helpers/color-tokens';

const BonusCardContainer = styled.div`
	height: 100%;
	position: relative;
	backdrop-filter: blur(10px);
	border-radius: 16px;
	background: ${bonusCardBackgroundColor}; /* 0.7 is the opacity for the background color */

	/* Shadow04 */
	box-shadow: ${isNewBrandDesign()
		? 'none'
		: '0px 8px 24px 0px rgba(0, 14, 38, 0.05), 0px 4px 16px 0px rgba(0, 14, 38, 0.1)'};
`;

export const BonusCard: React.FC<{
	bonus: Bonus;
	shouldDisplayGetButton: boolean;
	carouselMode: CarouselModeEnum;
	handleClickBonus: () => void;
	showButton?: boolean;
}> = ({ bonus, shouldDisplayGetButton, carouselMode, handleClickBonus, showButton = true }) => {
	return (
		<ThemeProvider>
			<BonusCardContainer className="bonus-card-container" onClick={handleClickBonus}>
				<Container horizontalAlign={'center'} wrap="always">
					<AspectRatioContainer ratio="3:2">
						<Image
							src={bonus.imageUrl || IMAGE_DEFAULT_VWLOGO}
							objectFit="cover"
							alt="Bonus_image"
							style={{
								borderTopLeftRadius: '16px',
								borderTopRightRadius: '16px',
								borderBottomLeftRadius: '16px',
								borderBottomRightRadius: '16px',
							}}
						/>
					</AspectRatioContainer>

					<BonusDescription
						bonus={bonus}
						shouldDisplayGetButton={shouldDisplayGetButton}
						carouselMode={carouselMode}
						showButton={showButton}
					/>
				</Container>
			</BonusCardContainer>
		</ThemeProvider>
	);
};
